import React, { useState } from 'react';
import T from 'prop-types';

import Modal from '../../../Modal';
import Button from '../../../Buttons/Button';
import { toast } from '../../../Toasts';
import api from '../../api';

const UnScheduleExportModal = ({ open, report, onClose, onSuccess }) => {
  const [processing, setProcessing] = useState(false);

  const handleConfirm = () => {
    setProcessing(true);
    api
      .unScheduleExport(report.id)
      .then(() => {
        setProcessing(false);
        onSuccess();
      })
      .catch(() => {
        toast.error('Sorry, something went wrong while cancelling the schedule. Please try again.');
        setProcessing(false);
        onClose();
      });
  };

  return (
    <Modal
      open={open}
      size="xs"
      closeButtonIconClass="hicon-close-2"
      modalClassName="unschedule-export-modal"
      onClose={onClose}
    >
      <div className="unschedule-export-modal__body">
        <h3 className="unschedule-export-modal__title h3">Cancel scheduled export?</h3>
        <small className="unschedule-export-modal__description">
          This export will no longer run automatically.
          <br /> You can reschedule it at any time.
        </small>
      </div>

      <div className="unschedule-export-modal__footer">
        <Button size="lg" variant="secondary" onClick={onClose}>
          Keep schedule
        </Button>
        <Button size="lg" loading={processing} disabled={processing} onClick={handleConfirm}>
          Cancel schedule
        </Button>
      </div>
    </Modal>
  );
};

UnScheduleExportModal.propTypes = {
  open: T.bool.isRequired,
  report: T.object,
  onClose: T.func.isRequired,
  onSuccess: T.func.isRequired,
};

export default UnScheduleExportModal;
